import { AutocompleteLoadingModeType, IAutocompleteSchema, ToastService } from "maps-angular-components";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { GrupoCarteira } from "src/app/grupo-carteira/grupo-carteira";
import { BehaviorSubject, Subject, Subscription } from "rxjs";
import { GrupoCarteiraService } from "src/app/grupo-carteira/grupo-carteira.service";
import { CarteiraService } from "src/app/carteira/carteira.service";
import { MatDialog } from "@angular/material/dialog";
import { indicate } from "src/app/shared/util/loading-indicate";
import { ModalDeletarAssociacaoGrupoCarteiraComponent } from "src/app/associacao-grupo-carteira/modal-deletar-associacao-grupo-carteira/modal-deletar-associacao-grupo-carteira.component";
import { AssociacaoGrupoCarteiraVO } from "src/app/grupo-carteira/associacao-grupo-carteira";
import { Carteira } from "src/app/carteira/carteira.model";
import { BrowserSupport } from "src/app/shared/util/browser-support";

@Component({
  selector: "app-associacao-grupo-carteira-gerenciador",
  templateUrl: "./associacao-grupo-carteira-gerenciador.component.html",
})
export class AssociacaoGrupoCarteiraGerenciadorComponent implements OnInit, OnDestroy {

  grupocarteiraSchema: IAutocompleteSchema<GrupoCarteira>;

  carteiraSchema: IAutocompleteSchema<Carteira>;

  associacoesGrupoCarteira: AssociacaoGrupoCarteiraVO[] = [];

  totalRegistros = 0;

  paginationTotalPage = 0;

  page$: Subject<number> = new Subject<number>();

  loading$ = new BehaviorSubject(false);

  loadingExport$ = new Subject<boolean>();

  exportEnabled = false;

  private pageSize = 20;

  form: FormGroup;

  private readonly subscriptions = new Subscription();

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly grupoCarteiraService: GrupoCarteiraService,
    private readonly carteiraService: CarteiraService,
    private readonly messageService: ToastService,
    private readonly dialog: MatDialog
  ) {
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      idGrupoCarteira: new FormControl(),
      idCarteira: new FormControl(),
      page: new FormControl(0),
    });

    this.page$.subscribe(value => this.form.controls["page"].setValue(value - 1));

    this.grupocarteiraSchema = {
      service: this.grupoCarteiraService,
      endpoint: "",
      label: "Grupo carteira",
      loadingMode: AutocompleteLoadingModeType.LAZY,
      autoload: false,
      formGroup: this.form,
      formControlName: "idGrupoCarteira",
      panelClass: "w-100",
      parseSearchParam: search => search,
    };

    this.carteiraSchema = {
      service: this.carteiraService,
      endpoint: "nome-ou-cnpj-ativo",
      label: "Carteira",
      loadingMode: AutocompleteLoadingModeType.LAZY,
      autoload: false,
      formGroup: this.form,
      formControlName: "idCarteira",
      panelClass: "w-100",
      parseSearchParam: search => search,
    };
  }

  receivePage(value: any) {
    this.page$.next(value);
    this.pesquisar(this.form);
  }

  onChangeTotalPagina(event) {
    this.pageSize = event;
    this.page$.next(1);
    this.pesquisar(this.form);
  }

  pesquisar(form: FormGroup): void {
    this.associacoesGrupoCarteira = [];

    const { idGrupoCarteira, idCarteira, page } = form.value;

    this.grupoCarteiraService
      .getAssociacoesGrupoCarteira(idGrupoCarteira, idCarteira, page, this.pageSize)
      .pipe(indicate(this.loading$))
      .subscribe(
        res => {
          this.exportEnabled = true;
          this.totalRegistros = res.metadata.totalElements;
          this.paginationTotalPage = res.metadata.totalElements > 0 ? Math.ceil(res.metadata.totalElements / res.metadata.size) : 1;
          this.associacoesGrupoCarteira = res.content;
          this.form.get("page").setValue(res.metadata.number);
        },
        err => this.messageService.erro(err.error.message)
      );
  }

  exportarPdf() {
    const { idGrupoCarteira, idCarteira, page } = this.form.value;

    this.subscriptions.add(
      this.grupoCarteiraService
        .exportAssociacoesGrupoCarteiraPdf(idGrupoCarteira, idCarteira, page, this.pageSize)
        .pipe(indicate(this.loadingExport$))
        .subscribe(
          data => BrowserSupport.savePDF(data),
          err => this.messageService.erro(err.error.message)
        )
    );
  }

  exportarXls() {
    const { idGrupoCarteira, idCarteira, page } = this.form.value;

    this.subscriptions.add(
      this.grupoCarteiraService
        .exportAssociacoesGrupoCarteiraXlsx(idGrupoCarteira, idCarteira, page, this.pageSize)
        .pipe(indicate(this.loadingExport$))
        .subscribe(
          data => BrowserSupport.saveXlsx(data),
          err => this.messageService.erro(err.error.message)
        )
    );
  }

  openDeleteDialog(associacaoGrupoCarteiraVO: AssociacaoGrupoCarteiraVO) {
    const dialogRef = this.dialog.open(ModalDeletarAssociacaoGrupoCarteiraComponent, {
      data: associacaoGrupoCarteiraVO,
      width: "800px"
    });

    dialogRef.componentInstance.associacaoGrupoCarteiraExcluida.subscribe(() => {
      this.pesquisar(this.form)
      dialogRef.close()
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
